'use client';

import {Typography} from '@pixel-party/Typography/v2';
import type React from 'react';
import {useTranslation} from 'react-i18next';
import {REGISTRY} from '@/app/forms/_registry/client';
import styles from './FiberBlogForm.module.scss';

function FiberBlogForm(): React.JSX.Element {
  const {t} = useTranslation();
  const config = REGISTRY.FiberBlogForm;

  const iframeUrl = 'https://cloud.go.gfiber.com/gfiberblog';

  return (
    <>
      <Typography
        use="headline2"
        className={styles.title}
      >
        {t(config.title)}
      </Typography>
      <iframe
        src={iframeUrl}
        className="w-full min-h-[31.25rem]"
        title={t(config.title)}
      />
    </>
  );
}

export {FiberBlogForm};
